// extracted by mini-css-extract-plugin
module.exports = {"input":"FieldCurrencyInput_input__QJ9Ts","inputSuccess":"FieldCurrencyInput_inputSuccess__FGYT4","inputError":"FieldCurrencyInput_inputError__3Cba3"};